// 添加埋点事件
class CustomEventGa extends HTMLElement {
    constructor() {
      super();
      this.handleEvent = this.handleEvent.bind(this);
      this.loginInit();
      this.socialClick();
      this.activeClick();
    }

    shareToSocialMedia(platform, url, title,hashtags) {
      const socialMediaUrl = {
        facebook:
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(url) +
          '&hashtag=' +
          encodeURIComponent(title),
        twitter:
          'https://twitter.com/intent/tweet?url=' +
          encodeURIComponent(url) +
          '&text=' +
          encodeURIComponent(title) +
          '&hashtags=' +
          encodeURIComponent(hashtags)
      }
    
      window.open(socialMediaUrl[platform], '_blank')
    }
    
    // 社媒分享点击
    socialClick(){
      const socialList = document.querySelectorAll('.public-social-contain .social-list .tm-item');
  
      socialList.forEach((item) => {
        
        item.addEventListener('click', (event) => {
          const type = event.target.getAttribute('data-type');
          switch (type) {
            case 'facebook':
               this.shareToSocialMedia("facebook", window.location.href, document.title,"Bluetti Global");
              break;
              case 'twitter':  
              this.shareToSocialMedia("twitter", window.location.href, document.title,"bluettipower");
              break;
            case 'ins':
            window.open("https://www.instagram.com/bluetti_official", '_blank');
              break; 
            case 'youtube':
            window.open("https://www.youtube.com/channel/UC__Tu8lHDpThTB2EIpfbJ7Q", '_blank');
              break;  
            default:
              break;
          }
          
         
        });
      });  
    }

    // 活动页面点击模态弹出层
    activeClick(){
        const activeList = document.querySelectorAll('.banner-icon-item');
        if(activeList.length == 0) return;
        activeList.forEach((item) => {
          item.addEventListener('click', (event) => {
            const url = event.target.getAttribute('data-url');
            if(!url) return; 
            activeList.forEach((el) => el.classList.remove('active'));
            item.classList.add('active');
            var btn_list = document.querySelectorAll(".index-dialog-swiper .sign-go-btn");
            btn_list.forEach((el) => {
              el.classList.remove("hidden");
              el.querySelector("a").setAttribute("href",url);
            });
          })
        })

        // 点击关闭弹出层操作
        const closeList = document.querySelectorAll('.index-dialog-swiper .btnclose');
        closeList.forEach((item) => {
          item.addEventListener('click', (event) => {
            var btn_list = document.querySelectorAll(".index-dialog-swiper .sign-go-btn");
            btn_list.forEach((el) => {
              el.classList.add("hidden");
              el.querySelector("a").setAttribute("href","");
            });
            activeList.forEach((el) => el.classList.remove('active'));

          })
        })
    }
  
  
    connectedCallback() {
      this.userRole = this.dataset.userRole;
      this.pageName = this.dataset.pageName;
      this.belongAreasEl = this.querySelectorAll('[data-belong-area]');
  
      this.init();
    }
    
    loginInit() {
      var goLoginList = this.querySelectorAll('.public-login-link');
      if (goLoginList.length == 0) return;
      goLoginList.forEach(function (item) {
        item.addEventListener('click', function (event) {
          var link = event.target.dataset.link;
          var loginEl = document.querySelector('.public-email-send-code');
          loginEl.style.display = 'flex';
          if (link) {
            loginEl.redirect = link;
          }
        });
      });
    }
  
  
    init() {
      document.addEventListener('click', (event) => {
        var target = event.target;
        var belongAreasEl = target.closest('[data-belong-area]');
        var eventHandlesEl = target.getAttribute('data-event');
        if (belongAreasEl && eventHandlesEl) {
          var belongAreaParam = belongAreasEl.dataset.belongArea || 'N/A';
          var parameters = target.dataset?.eventParameters;
          if (!parameters) return;
  
          try {
            var formatParameters = JSON.parse(parameters);
            this.handleEvent(eventHandlesEl, eventHandlesEl, {
              user_role: this.userRole,
              page_name: this.pageName,
              belong_area: belongAreaParam,
              ...formatParameters,
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
  
    handleEvent(el, event = 'click', parameters) {
      //console.log('event', event, parameters);
      window.gtag('event', event, parameters);
    }
  }
  
if (!customElements.get('custom-event')) {
  customElements.define('custom-event', CustomEventGa);
}

function updateOffsetHeightProperty() {
  const countdownElement = document.querySelector("#shopify-section-countdown-time");
  const announcementElement = document.querySelector(".section-announcement-bar");
  const headerSection= document.querySelector(".shopify-section-header");

  const countdown_height = countdownElement && countdownElement.getBoundingClientRect().height || 0;
  const announcement_height = announcementElement && announcementElement.getBoundingClientRect().height || 0;
  const header_height = headerSection && headerSection.getBoundingClientRect().height || 0;
  
  document.documentElement.style.setProperty('--header-nav-height', `${header_height}px`);
  document.documentElement.style.setProperty('--countdown-height', `${countdown_height}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcement_height}px`);
}

window.addEventListener('loaded', updateOffsetHeightProperty());

window.addEventListener('resize', ()=> {
  window.Shopify.debounce(updateOffsetHeightProperty(), 200);
})

window.addEventListener('countdown-end', ()=> {
  window.Shopify.debounce(updateOffsetHeightProperty(), 200);
})